import React from "react";

import { useForm } from ".";
import { Characteristic } from "./Characteristic";

interface Props {
  categoryName: string;
  viewOnly: boolean;
  subcategoryId?: number;
}

export const Category: React.FC<Props> = ({ categoryName, viewOnly, subcategoryId }) => {
  const { getCharacteristics } = useForm();

  const characteristics = getCharacteristics({
    category_name: categoryName,
    is_deleted: false,
    subcategory_ids: []
  });

  return (
    <>
      {characteristics.map((item) => (
        <Characteristic key={item.id} {...item} viewOnly={viewOnly} subcategoryId={subcategoryId} />
      ))}
    </>
  );
};
